import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ImageLibraryContainer, type ImageLibraryContainerProps,
} from './imageLibrary.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ImageLibrary: ImageLibraryContainerProps;
  }
}
modalRenderer.register('ImageLibrary', ImageLibraryContainer);
